module.exports = __webpack_public_path__ + "static/Savorly_Footer-cb9293b04fd49e0a300341badb627e91.png";